import { __awaiter, __generator } from "tslib";
var Eway = (function () {
    function Eway(_httpClient) {
        this._httpClient = _httpClient;
    }
    Eway.prototype.TokenizeCreditCard = function (authResponse, creditCard, _customerRef) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._loadEWayJsonPScript(this._httpClient.defaults.baseURL + "/JSONP/v3/js")];
                    case 1:
                        _a.sent();
                        return [2, new Promise(function (resolve, reject) {
                                var form = _this._buildForm(authResponse.actionUrl, _this._getFields(authResponse, creditCard));
                                document.body.appendChild(form);
                                window["eWAY"].process(form, {
                                    autoRedirect: false,
                                    onComplete: function (response) {
                                        form.remove();
                                        resolve({
                                            redirectUrl: response.RedirectUrl,
                                            resultToken: response.AccessCode,
                                        });
                                    },
                                    onError: function (e) {
                                        form.remove();
                                        reject(e);
                                    },
                                    onTimeout: function (e) {
                                        form.remove();
                                        reject(e);
                                    },
                                });
                            })];
                }
            });
        });
    };
    Eway.prototype.TokenizeBankAccount = function (_authResponse, _bankAccount, _customerRef) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("Not Implemented");
            });
        });
    };
    Eway.prototype.TokenizeOw30DayAccount = function (_popup) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("Not Implemented");
            });
        });
    };
    Eway.prototype._getFields = function (authResponse, creditCard) {
        return new Map([
            ["EWAY_ACCESSCODE", authResponse.token],
            ["EWAY_PAYMENTTYPE", "Credit Card"],
            ["EWAY_CARDNAME", creditCard.cardHolderName],
            ["EWAY_CARDNUMBER", creditCard.cardNumber],
            ["EWAY_CARDEXPIRYMONTH", creditCard.expiryMonth],
            ["EWAY_CARDEXPIRYYEAR", creditCard.expiryYear],
        ]);
    };
    Eway.prototype._buildForm = function (actionUrl, fields) {
        var form = document.createElement("form");
        form.style.display = "none";
        form.setAttribute("method", "post");
        form.setAttribute("action", actionUrl);
        fields.forEach(function (v, k) {
            var formField = document.createElement("input");
            formField.setAttribute("type", "hidden");
            formField.setAttribute("name", k);
            formField.setAttribute("value", v);
            form.appendChild(formField);
        });
        return form;
    };
    Eway.prototype._loadEWayJsonPScript = function (src) {
        return new Promise(function (resolve, reject) {
            if (window["eWAY"]) {
                resolve();
            }
            else {
                var eWayJsonPScript = document.createElement("script");
                eWayJsonPScript.setAttribute("type", "text/javascript");
                eWayJsonPScript.setAttribute("src", src);
                eWayJsonPScript.async = true;
                eWayJsonPScript.onload = resolve;
                eWayJsonPScript.onerror = reject;
                document.head.appendChild(eWayJsonPScript);
            }
        });
    };
    return Eway;
}());
export { Eway };
//# sourceMappingURL=Eway.js.map